/**
 * Created by zoechodosh on 1/4/17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { RenderField, RenderTextareaField, RenderSubmitButton, RenderSelectField, RenderHiddenField } from '../../../common/form';
import FileInput from '../../../common/form/FileInput';
import { updateWeddingPartyMember, addWeddingPartyMember } from '../../../../actions/website/entities/WeddingPartyMembersActions';
import { WeddingPartyMemberRoles } from './WeddingPartyMemberRoles';
import * as Validations from '../../../common/form/commonValidations';
import { hideModal } from '../../../../actions/ModalActions';
import { saveCrop, tempUpload } from '../../../../actions/website/FileUploadActions';
import CropModal from './CropModal';

class WeddingPartyMemberForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cropOpen: false
    };
  }
  componentWillReceiveProps(nextProps) {
    const { onPhotoSelected } = this.props;
    if (nextProps.filePreview.s3_key && (this.props.filePreview.s3_key !== nextProps.filePreview.s3_key)) {
      this.setState({ cropOpen: true });
    } else if (nextProps.filePreview.uuid && (this.props.filePreview.uuid !== nextProps.filePreview.uuid)) {
      this.setState({ cropOpen: false });
      onPhotoSelected(nextProps.filePreview.uuid);
    }
  }
  render() {
    const { handleSubmit, pristine, submitting, hasCustomRole, valid, onPhotoSelect, filePreview, imageUrl, isUpdate, savePhotoCrop } = this.props;
    return (
      <div className="entity-form">
        <div className="modal-header">
          <h3 className="modal-title">{isUpdate ? 'Edit' : 'Add'} Person</h3>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit} id="wedding-party-member-form" noValidate>
            <Field
              name="name"
              type="text"
              label="Name"
              id="wedding-party-member-name"
              component={RenderField}
              required
              maxChars={30}
              validate={[Validations.REQUIRED, Validations.MAX_LENGTH_30]}
              disabled={this.state.cropOpen}
            />
            <Field
              name="role"
              label="Role"
              id="wedding-party-member-role"
              options={WeddingPartyMemberRoles}
              component={RenderSelectField}
              required
              validate={Validations.REQUIRED}
              disabled={this.state.cropOpen}
            />
            {
              hasCustomRole &&
              <Field
                name="custom_role"
                type="text"
                label="Custom Role"
                id="custom-role"
                component={RenderField}
                maxChars={60}
                required
                validate={[Validations.REQUIRED, Validations.MAX_LENGTH_60]}
                disabled={this.state.cropOpen}
              />
            }
            <Field
              name="description"
              id="wedding-party-member-description"
              label="Description"
              component={RenderTextareaField}
              maxChars={800}
              rows={5}
              placeholder="We shared a cubby in pre-school—we were neat freaks then and neat freaks now, as evidenced by the spotless apartment we shared until my engagement!"
              validate={Validations.MAX_LENGTH_800}
              disabled={this.state.cropOpen}
            />
            <Field
              component={RenderHiddenField}
              name="image_id"
            />
            <strong className="form-label">Photo <small>(max file size 5 MB)</small></strong>
            {!this.state.cropOpen && !filePreview.busy &&
            <FileInput inputId="wedding_party" onSelect={onPhotoSelect} filePreview={filePreview.cloudfront_url ? filePreview.cloudfront_url : imageUrl} />
            }
            {this.state.cropOpen && filePreview.s3_key && !filePreview.busy &&
            <CropModal onCropSelect={crop => savePhotoCrop(crop, filePreview)} aspectRatio={1} imageUrl={filePreview.url} minimal />
            }
            {filePreview.busy &&
            <div className="busy-loader margin-top margin-bottom center-block" />
            }
            <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} disabled={this.state.cropOpen || filePreview.busy} />
          </form>
        </div>
      </div>
    );
  }
}

WeddingPartyMemberForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  hasCustomRole: PropTypes.bool,
  valid: PropTypes.bool.isRequired,
  onPhotoSelect: PropTypes.func,
  filePreview: PropTypes.shape({
    uuid: PropTypes.string,
    s3_key: PropTypes.string
  }),
  onPhotoSelected: PropTypes.func,
  imageUrl: PropTypes.string,
  isUpdate: PropTypes.bool,
  savePhotoCrop: PropTypes.func
};

const WeddingPartyMemberFormInstance = reduxForm({
  form: 'weddingPartyMemberForm',
  enableReinitialize: true
})(WeddingPartyMemberForm);

const selector = formValueSelector('weddingPartyMemberForm');

const mapStateToProps = state => (
  {
    initialValues: state.website.entities.byId[state.website.entities.selectedEntityId],
    hasCustomRole: selector(state, 'role') === 'CUSTOM',
    filePreview: state.website.entities.filePreview.wedding_party || {},
    imageUrl: state.website.entities.selectedEntityId ? state.website.entities.byId[state.website.entities.selectedEntityId].image_url : undefined
  }
);

const mapDispatchToProps = dispatch => (
  {
    onSubmit: (weddingPartyMemberFormRequest) => {
      if (weddingPartyMemberFormRequest.id) {
        dispatch(updateWeddingPartyMember(weddingPartyMemberFormRequest));
      } else {
        dispatch(addWeddingPartyMember(weddingPartyMemberFormRequest));
      }
      dispatch(hideModal());
    },
    onPhotoSelect: (file) => {
      dispatch(tempUpload(file, 'wedding_party'));
    },
    savePhotoCrop: (crop, image) => {
      dispatch(saveCrop(image.s3_bucket, image.s3_key, crop, image.content_type, 'wedding_party'));
    },
    onPhotoSelected: (imageId) => {
      dispatch(change('weddingPartyMemberForm', 'image_id', imageId));
    }
  }
);

const WeddingPartyMemberFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WeddingPartyMemberFormInstance);

export default WeddingPartyMemberFormContainer;



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/WeddingPartyMemberForm.jsx
 **/